import { useEffect, useState } from "react";
import {
  DataGrid,
  GridToolbar,
  gridFilteredSortedRowIdsSelector,
} from "@mui/x-data-grid";
import SettingsIcon from "@mui/icons-material/Settings";
import { Stack, Typography, Alert } from "@mui/material";

// Always export the full filtered/sorted dataset (never only the selected row)
const getRowsToExport = ({ apiRef }) =>
  gridFilteredSortedRowIdsSelector(apiRef);

// ...props are any other props for MUI DataGrid component

const gridStyle = {
  mb: 7,

  // ".MuiDataGrid-columnSeparator": {
  //   display: "none",
  // },
  // "& .MuiDataGrid-columnHeaders": {
  //   background: "rgba(74, 87, 169, 0.1)",
  //   color: "#46464E",
  // },
  "& .MuiDataGrid-main": {
    paddingBottom: "20px",
  },
  ".MuiDataGrid-row": {
    background: "#FEFBFF",
    borderbottom: "1px solid #767680",
  },
  "& .rightAlignedCell": {
    textAlign: "right",
    justifyContent: "flex-end",
    display: "flex",
  },
  "& .MuiDataGrid-cell": {
    display: "flex !important",
    alignItems: "center !important",
    // justifyContent: "center !important",
  },
  "& .MuiDataGrid-columnHeaderGroup": {
    justifyContent: "center !important",
  },
  "& .MuiDataGrid-columnHeaderTitleContainer": {
    justifyContent: "center !important",
    width: "100%",
  },
  "& .MuiDataGrid-columnHeaderGroup .MuiDataGrid-columnHeaderTitle": {
    textAlign: "center",
    fontWeight: "bold",
    width: "100%",
    justifyContent: "center !important",
  },
};

const CustomNoRowsOverlay = () => (
  <Stack height="100%" alignItems="center" justifyContent="center">
    <Typography variant="body2" color="textSecondary">
      No rows
    </Typography>
  </Stack>
);

const CustomErrorOverlay = ({ error }) => (
  <Stack
    height="100%"
    alignItems="center"
    justifyContent="center"
    sx={{ p: 2 }}
  >
    <Alert severity="error" sx={{ maxWidth: 600 }}>
      {error}
    </Alert>
  </Stack>
);

function GridIndex({
  rows,
  columns,
  rowCount = 0,
  page,
  pageSize,
  handleOnPageChange,
  handleOnPageSizeChange,
  loading,
  getRowClassName,
  handleOnFilterChange,
  columnVisibilityModel = {},
  setColumnVisibilityModel = () => {},
  onRowClick = () => {},
  error = null,
  disableRowSelectionOnClick = true,
  ...props
}) {
  const [updatePageSize, setUpdatePageSize] = useState(pageSize);

  useEffect(() => {
    setUpdatePageSize(pageSize);
  }, [pageSize]);

  const CustomButton = () => <SettingsIcon />;

  const overlayComponent = error
    ? () => <CustomErrorOverlay error={error} />
    : CustomNoRowsOverlay;

  if (pageSize) {
    props.rowCount = rowCount;
    props.page = page;
    props.paginationMode = "server";
    // props.onPageChange = handleOnPageChange;
    props.onPaginationModelChange = (model) => handleOnPageChange(model.page);
    props.onPageSizeChange = handleOnPageSizeChange;
    props.filterMode = "server";
    props.onFilterModelChange = handleOnFilterChange;
  } else {
    props.onPageSizeChange = (newPageSize) => setUpdatePageSize(newPageSize);
    // Callers driving v7 pagination themselves (paginationModel +
    // paginationMode="server") still need rowCount forwarded; it is
    // destructured out of props above. Skipped in client mode, where MUI
    // warns about an explicit rowCount.
    if (props.paginationMode === "server") props.rowCount = rowCount;
  }

  return (
    <DataGrid
      autoHeight
      rows={rows}
      columns={columns}
      getRowId={(row) => row.id}
      columnVisibilityModel={columnVisibilityModel}
      onColumnVisibilityModelChange={(newModel) =>
        setColumnVisibilityModel(newModel)
      }
      // components={{
      //   Toolbar: GridToolbar,
      //   MoreActionsIcon: CustomButton,
      // }}
      // componentsProps={{
      //   toolbar: {
      //     showQuickFilter: true,
      //     quickFilterProps: { debounceMs: 500 },
      //   },
      // }}
      disableRowSelectionOnClick={disableRowSelectionOnClick}
      slots={{
        toolbar: GridToolbar,
        moreActionsIcon: CustomButton,
        noRowsOverlay: overlayComponent,
      }}
      slotProps={{
        toolbar: {
          showQuickFilter: true,
          quickFilterProps: { debounceMs: 500 },
          csvOptions: { getRowsToExport },
          printOptions: { getRowsToExport },
        },
      }}
      sx={{
        ...gridStyle,
        ...props.sx,
      }}
      // pageSize={updatePageSize ? updatePageSize : 100}
      // rowsPerPageOptions={[50, 100]}
      pageSizeOptions={[50, 100]}
      pageSize={updatePageSize || 100}
      scrollbarSize={0}
      density="compact"
      loading={loading}
      getRowClassName={getRowClassName}
      onRowClick={onRowClick}
      {...props}
    />
  );
}

export default GridIndex;
